import React, { useState, useEffect } from 'react'
import config from "../../config";
import { Card, Button } from 'react-bootstrap';
import { handleElasticProductSearchData } from './handleElasticProductSearchData'
import classes from './Inventoryproducts.module.css'
import ProductCardElastic from "../../components/ProductCardElastic";
//import LazyLoad from 'react-lazyload';
import RequestManager from "../../singletons/RequestManager";
import LoadingOverlay from "react-loading-overlay";
import { useParams,useHistory } from 'react-router-dom';
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";

function Inventoryproducts(props) {
  const [Templateinventory, setTemplateinventory] = useState([]);
  const [selectedstore, setSelectedstore] = useState()
  const [products, setProducts] = useState([]);
  const [selectedTemplateStore, setTemplateStoreId] = useState([]);
  const [spinnerLoading, setSpinnerLoading] = useState(true);

  var category_id = props.match.params.id;
  let category_name = props.match.params.name;
  let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
  let storeid = storeInformation.store.id;

  // console.log(category_id,"locationkkkkkkkkkkk")

  useEffect(() => {
  //getUserProfile()
  //console.log('STEP-2');
  getTemplateStoreId()
  if (selectedTemplateStore != null ){
    //console.log('STEP-5');
    getProductsForCategoryElastic(category_id,selectedstore)
  }
  else{
    //console.log('STEP-6');
    getInventoryNormal(category_id,selectedstore)
  }
 }, [category_id,selectedstore]);

  const getTemplateStoreId = () =>{
    //console.log('STEP-3');
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    //console.log('STEP-4', storeInformation.store.businessDomain.templateStoreId);
    setTemplateStoreId(storeInformation.store.businessDomain.templateStoreId);
  }
    // console.log(selectedstore,"selectedstore selectedstore")
    const getProductsForCategoryElastic = async (category_id, selectedstore) => {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      let storeid = storeInformation.store.id;
      setSelectedstore(storeid)
      // console.log(storeid, "storeid")
      let authToken = storeInformation.token;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Token " + authToken);
  
      // region_name
      try {
        var vtimestamp = generateEpochTimestamp();
        let response = await fetch(
          config.getHost() + "/product/elasticsearch/",
          {
            method: "POST",
            headers: {
              Authorization: `Token ${authToken}`,
              "Content-Type": "application/json",
              Timestamp: vtimestamp,
              Signature: generateSignature(vtimestamp, authToken)                
            },
            body: JSON.stringify({
              store_id: storeid,
              search_text: '',
              category_id: category_id,
              product_id: '',
              stock_id: '',
              sku_ids: '',
              autocomplete: false,
              is_search: false
            }),
          }
        );
  
      if (response.status === 200) {
          let json = await response.json();
          let res = JSON.parse(json);
       
          let result = await res.hits.hits;
      //  console.log("result", result);
          
            setTemplateinventory(result)
   
            setSpinnerLoading(false)
        }
      } catch (error) {
        console.log("error", error);
      }
  
    };
  
    // const hanldebackclick = () =>{
    //   props.history.goBack();
    // }
    
   
  
    const getInventoryNormal = async (category_id, selectedstore) => {
      //  console.log(category_id,"category_id")
      //console.log("getInventoryNormal",category_id, selectedstore );
      let requestManager = new RequestManager();
  
      let data = await requestManager.getResponseFromPredefinedQuery(
        "getProductSKUsStocksForCategory",
        {
          storeId: selectedstore,
          categoryId: category_id,
          after: ''
        }
      );
        // console.log('products ====', data );
      if (data && data.data) {
       //console.log('STEP-7',data.data ) 
       setProducts(data.data.products.edges);
       setSpinnerLoading(false)
      
      } else if (data.errors === null) {
             alert(
          "Unable to update inventory. Please check your internet connection."
        );
      }
    };
  

  const getUserProfile = async () => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
    );
    
    // console.log(response.error,"response.error")

    if (response.error) {
       alert('Something went wrong. Please try again later.')
    } else {
      let res = response;
      //  console.log("businessdomain", JSON.stringify(res.data.userProfile.user.store.businessDomain.templateStoreId));
     var templatestoreid=JSON.stringify(res.data.userProfile.user.store.businessDomain.templateStoreId);
      setTemplateStoreId(templatestoreid)
      // localStorage.setItem("userProfile", JSON.stringify(res.data.userProfile));
    }
  };

  

//  console.log('products ====', Templateinventory );
  //  products.map(product=>console.log(product.node.name))


  return (
    <LoadingOverlay
    style={{ width: "100%", height: "100%", zIndex: 999 }}
    active={spinnerLoading === true ? true : false}
    spinner
    text="Loading ..."
  >
    {/* <div className="container-fluid mt-3 " > */}
      <button className="inventorybackbtn" onClick={() => props.history.goBack()}>Back</button>
      <center><h3>Your Inventory - {category_name} Category</h3></center>
      <hr />
      <div className="row px-sm-2 px-0 pt-3 ">

     
 
  { selectedTemplateStore == null &&
  products.map((product) => (
  /*<LazyLoad height={280} key={product.node.id} once overflow offset={10}>*/
      <ProductCardElastic  product={ product.node} storeid={storeid} type="Normal" />
    /*</LazyLoad>*/
   ))}
{ 
 selectedTemplateStore != null &&
 Templateinventory.map((pro,index) => (
    /*<LazyLoad height={280} key={index} once overflow offset={10}>*/
    <ProductCardElastic pro={pro} store={selectedstore} storeid={storeid} type="templatestore" />
  /*</LazyLoad>*/
  ))}   
   </div>


    {/* </div> */}
</LoadingOverlay>
  )
}

export default Inventoryproducts






// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/Inventoryproducts.js